import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiGooglescholar } from "react-icons/si";
import React from "react";

const footerConfig = {
    icons: [
        {
            id: "footer-0",
            url: "https://github.com/Magcores",
            className: "social-icon",
            target: "_blank",
            icon: <AiFillGithub size={50} />
        },
        {
            id: "footer-1",
            url: "https://www.linkedin.com/in/martinantunez/",
            className: "social-icon",
            target: "_blank",
            icon: <FaLinkedinIn size={50} />
        },
        {
            id: "footer-2",
            url: "https://scholar.google.com/citations?user=-UWHw0sAAAAJ&hl=en&oi=ao",
            className: "social-icon",
            target: "_blank",
            icon: <SiGooglescholar size={50} />
        }
    ]
}

export default footerConfig
